export const permissions = {
  liveStatus: {
    view: "liveStatus_view",
    modify: "liveStatus_modify",
  },
  analytics: {
    view: "analytics_view",
    modify: "analytics_modify"
  },
  alarms: {
    view: "alarms_view",
    modify: "alarms_modify"
  },
  chargingStations: {
    view: "chargingStations_view",
    modify: "chargingStations_modify"
  },
  chargePoint: {
    view: "chargePoint_view",
    modify: "chargePoint_modify"
  },
  rfid: {
    view: "rfid_view",
    modify: "rfid_modify"
  },
  evChargersModel: {
    view: "evChargersModel_view",
    modify: "evChargersModel_modify"
  },
  evVehicle: {
    view: "evVehicle_view",
    modify: "evVehicle_modify"
  },
  manufacture: {
    view: "manufacture_view",
    modify: "manufacture_modify"
  },
  chargingTransaction: {
    view: "chargingTransaction_view",
    modify: "chargingTransaction_modify"
  },
  chargeLogs: {
    view: "chargeLogs_view",
    modify: "chargeLogs_modify"
  },
  accountTransactions: {
    view: "accountTransactions_view",
    modify: "accountTransactions_modify"
  },
  searchCustomer: {
    view: "searchCustomer_view",
    modify: "searchCustomer_modify"
  },
  customerList: {
    view: "customerList_view",
    modify: "customerList_modify"
  },
  chargingTariff: {
    view: "chargingTariff_view",
    modify: "chargingTariff_modify"
  },
  assignTariff: {
    view: "assignTariff_view",
    modify: "assignTariff_modify"
  },
  tax: {
    view: "tax_view",
    modify: "tax_modify"
  },
  activeSessions: {
    view: "activeSessions_view",
    modify: "activeSessions_modify"
  },
  startRemoteSession: {
    view: "startRemoteSession_view",
    modify: "startRemoteSession_modify"
  },
  emailNotification: {
    view: "emailNotification_view",
    modify: "emailNotification_modify"
  },
  inAppNotification: {
    view: "inAppNotification_view",
    modify: "inAppNotification_modify"
  },
  report: {
    view: "report_view",
    modify: "report_modify"
  },
  logs: {
    view: "logs_view",
  },
  // adminManagement: {
  //   view: "report_view",
  //   modify: "report_modify"
  // },
  adminManagement: {
    view: "adminManagement_view",
    modify: "adminManagement_modify"
  },
  roleManagement: {
    view: "roleManagement_view",
    modify: "roleManagement_modify"
  },
  adminActivity: {
    view: "adminActivity_view",
    modify: "adminActivity_modify"
  }
};


